// A Google Sheets URL always starts with this host + path prefix.
export const GOOGLE_SHEET_URL_PREFIX = 'https://docs.google.com/spreadsheets/';

export const isValidGoogleSheetUrl = (url: string): boolean =>
  typeof url === 'string' && url.trim().startsWith(GOOGLE_SHEET_URL_PREFIX);
